import { render, staticRenderFns } from "./OptionHeader.vue?vue&type=template&id=63a2ec1e"
import script from "./OptionHeader.vue?vue&type=script&lang=js"
export * from "./OptionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports